import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassColumn4, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

interface OwnProps {
	isDisabled: boolean;
}

type Props = OwnProps;

const EnvironmentalProtectionSection: React.FC<Props> = (props) => {
	const { isDisabled } = props;
	const checkboxStyle = React.useMemo(() => [formSectionClassColumn2, styles['job-form__tab-content__form-section__row__centered-column']].join(' '), []);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Environmental Protection"
				tooltip="Environmental considerations and protective measures required for this job, addressing potential impacts on water, wetlands, drainage systems, and sensitive ecological areas."
			/>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="waterOrWetlands"
						isDisabled={isDisabled}
						label="Water/Wetlands"
						name={JobUpsertFM.getAttributeName('waterOrWetlands')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="waterOrWetlandsDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('waterOrWetlandsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="stormDrain"
						isDisabled={isDisabled}
						label="Storm Drain"
						name={JobUpsertFM.getAttributeName('stormDrain')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="stormDrainDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('stormDrainDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="bypassPumping"
						isDisabled={isDisabled}
						label="Bypass Pumping"
						name={JobUpsertFM.getAttributeName('bypassPumping')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="byPassPumpingDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('bypassPumpingDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="sensitiveEnvironment"
						isDisabled={isDisabled}
						label="Sensitive Environment"
						name={JobUpsertFM.getAttributeName('sensitiveEnvironment')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="sensitiveEnvironmentDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('sensitiveEnvironmentDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(EnvironmentalProtectionSection);
